"use strict";

var _Routes;
import '@autoguru/overdrive/dist/styles/global/reset.css';
import '@autoguru/overdrive/dist/styles/global/fonts.css';
import { LoggingAgentProvider } from '@autoguru/logs';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { OverdriveProvider } from '@autoguru/overdrive';
import { SupportedBrowsersBoundary } from '@autoguru/supported-browser-boundary';
import { getMfeMountPoint } from 'gdu/dist/lib/mfe';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import AGSupportedBrowsers from '../browsers';
import * as guruConfigs from '../guru.config';
import { App } from './App';
import { jsx as _jsx } from "react/jsx-runtime";
const root = getMfeMountPoint({
  mountDOMId: guruConfigs.mountDOMId,
  projectName: __GDU_APP_NAME__
});
const MFE = () => {
  createRoot(root).render(/*#__PURE__*/_jsx(StrictMode, {
    children: /*#__PURE__*/_jsx(LoggingAgentProvider, {
      children: /*#__PURE__*/_jsx(OverdriveProvider, {
        children: /*#__PURE__*/_jsx(SupportedBrowsersBoundary, {
          browsers: AGSupportedBrowsers,
          children: /*#__PURE__*/_jsx(Router, {
            future: {
              v7_startTransition: true
            },
            children: _Routes || (_Routes = /*#__PURE__*/_jsx(Routes, {
              children: /*#__PURE__*/_jsx(Route, {
                path: ":tenantSlug/*",
                element: /*#__PURE__*/_jsx(App, {})
              })
            }))
          })
        })
      })
    })
  }));
};
export default MFE;